<template>
  <DurationDatePicker
    class="mt-0"
    :placeholder="'選擇'"
    :value="state"
  />
</template>

<script>
export default {
  data() {
    return {
      state: {}
    }
  }
}
</script>